(() => {
  const slides = document.querySelectorAll('.slideshow__slide');
  if (!slides.length) return;

  const playSafe = (video) => {
    video.muted = true;
    video.playsInline = true;
    const p = video.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  };

  const pauseAllInSlide = (slide) => {
    slide.querySelectorAll('video').forEach((v) => v.pause());
  };

  const playFirstInSlide = (slide) => {
    const v = slide.querySelector('video');
    if (v) playSafe(v);
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
        const slide = target;
        const visibleEnough = isIntersecting && intersectionRatio >= 0.6;

        if (visibleEnough) {
          // Pause videos in other slides (optional but recommended)
          slides.forEach((s) => s !== slide && pauseAllInSlide(s));
          playFirstInSlide(slide);
        } else {
          pauseAllInSlide(slide);
        }
      });
    },
    { threshold: [0, 0.25, 0.6, 1] }
  );

  slides.forEach((s) => io.observe(s));

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('.slideshow__slide video').forEach(v => v.pause());
  });
})();
